import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bernoulli-trial-calculator',
  component: () => import('../../routes/BernoulliTrial.svelte'),
  card: {
    id: 'bernoulli-trial-calculator',
    title: 'Bernoulli Trial Calculator',
    description:
      'Calculate binomial distribution probabilities — P(X=k), cumulative P(X≤k), and quantiles for independent success/failure trials.',
    icon: 'casino',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/bernoulli-trial-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Bernoulli Trial Calculator — Binomial Distribution Probability',
    description:
      'Free Bernoulli trial and binomial distribution calculator. Compute P(X=k) exact probability, cumulative P(X≤k), mean, variance, and quantiles for any number of independent trials.',
  },
};

export default meta;